var map = {
	"./argon-react-white.png": 1022,
	"./argon-react.png": 1023,
	"./banca_mediolanum.png": 1024,
	"./bancodesio.png": 1025,
	"./blue.png": 1026,
	"./conte-logo.png": 1027,
	"./elba-logo.png": 1028,
	"./favicon.png": 1029,
	"./optima.png": 1030,
	"./plick-logo.png": 512,
	"./plick_logo_white.png": 1031,
	"./plick_powered_by.png": 1032,
	"./poweredbyPayDo.png": 511,
	"./pugebas-logo.png": 1033,
	"./verti.png": 1034,
	"./white.png": 1035
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1021;